module.exports = __webpack_public_path__ + "img/30.96b6ab44.jpg";